import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TICKET_CATEGORIES_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import { useAlert } from "./../../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function CategoryDialog({
  editCategoryId,
  selectedCategoryId,
  categoryName,
  callCategories,
  isEdit
}) {
  const [openCategoryDialog, setOpenCategoryDialog] = useState(false);
  const [active, setActive] = useState(true);
  const [name, setName] = useState("");
  const showAlert = useAlert();


  const handleClickOpen = () => {
    if (editCategoryId !== "") {
      getCategory();
    } else {
      setOpenCategoryDialog(true);
    }
  };

  const handleClose = () => {
    setOpenCategoryDialog(false);
  };

  const handleActiveChange = (event) => {
    setActive(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSave = (stName) => {
    const payload = {};
    payload.name = stName;
    payload.active = active

    if (isEdit) {
      updateCategory(payload);
    } else {
      saveCategory(payload);
    }
  };

  const saveCategory = (payload) => {
    AxiosInstance.post(TICKET_CATEGORIES_URL, payload)
      .then((response) => {
        setActive(true);
        showAlert("Category created successfully!", "success");
        callCategories();
      })
      .catch((error) => {
        showAlert("Category creation failed!", "error");
        console.error(error);
      });
  };

  const updateCategory = (payload) => {
    AxiosInstance.put(`${TICKET_CATEGORIES_URL}/${editCategoryId}`, payload)
      .then((response) => {
        setActive(true);
        showAlert("Category updated successfully!", "success");
        callCategories();
      })
      .catch((error) => {
        showAlert("Category updation failed!", "error");
        console.error(error);
      });
  };

  const getCategory = () => {
    AxiosInstance.get(`${TICKET_CATEGORIES_URL}/${editCategoryId}`).then(
      (response) => {
        var categoryData = response.data.data;        
        setName(categoryData.name);
        setActive(categoryData.active);
        setOpenCategoryDialog(true);
      }
    );
  };
  return (
    <ThemeProvider>
      <React.Fragment>
        {editCategoryId === "" ? (

          < Tooltip
            title="Add Category"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px", float: "right" }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>

        ) : (
            <Link onClick={handleClickOpen}>{categoryName}</Link>
          )
        }

        <Dialog
          open={openCategoryDialog}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: 400, // fixed width
              height: 300, // fixed height
              maxWidth: "100%", // optional for responsiveness
              maxHeight: "100%", // optional to prevent overflow
            },
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const name = formJson.name;
              console.log(name);
              handleSave(name);
              handleClose();
            },
          }}
        >
          <DialogTitle>Add Category</DialogTitle>
          <DialogContent>
            {/* <DialogContentText>
                    To subscribe to this website, please enter your email address here. We
                    will send updates occasionally.
                  </DialogContentText> */}
            <TextField
              autoFocus
              required
              margin="dense"
              id="rg"
              name="name"
              label="Category"
              type="text"
              fullWidth
              value={name}
              variant="outlined"
              onChange={handleNameChange}
            />

            <br />
            <br />
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">
                Active
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={active}
                onChange={handleActiveChange}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default CategoryDialog;
